import { render, staticRenderFns } from "./CNameRecordForm.vue?vue&type=template&id=7ee234f4&"
import script from "./CNameRecordForm.vue?vue&type=script&lang=js&"
export * from "./CNameRecordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ee234f4')) {
      api.createRecord('7ee234f4', component.options)
    } else {
      api.reload('7ee234f4', component.options)
    }
    module.hot.accept("./CNameRecordForm.vue?vue&type=template&id=7ee234f4&", function () {
      api.rerender('7ee234f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Domains/ZoneEditor/Records/CNameRecordForm.vue"
export default component.exports